import HeroBar from "../../Components/HeroBar/HeroBar";
import SmarterReception from "../../Components/FeatureSection/SmarterReception/SmarterReception";
import TabSection from "../../Components/FeatureSection/TabSection/TabSection";
import CuttingEdge from "../../Components/FeatureSection/CuttingEdge/CuttingEdge";
import PreCallFeature from "../../Components/FeatureSection/PreCallFeature/PreCallFeature";
import PostCallFeature from "../../Components/FeatureSection/PostCallFeature/PostCallFeature";
import CustomerExperience from "../../Components/LandingSection/CustomerExperience/CustomerExperience";
import InCallFeature from "../../Components/FeatureSection/InCallFeature/InCallFeature";
import WhyRexpt from "../../Components/HomePageCTA.js/HomeCta";
const FeaturePage = ({
  featureHero,
  featureTab,
  fetchInCall,
  PostCallFeaturedata,
  fetchNMCuttingEdgedata,
  preCallfeaturedata,
  smarterReceptiondata,
}) => {
  return (
    <div>
      <HeroBar title={featureHero?.title} subtitle={featureHero?.subtitle} />
      <SmarterReception smarterReceptiondata={smarterReceptiondata} />
      <TabSection featureTab={featureTab} />
      <InCallFeature fetchInCall={fetchInCall} />
      <PostCallFeature PostCallFeaturedata={PostCallFeaturedata} />
      <CuttingEdge fetchNMCuttingEdgedata={fetchNMCuttingEdgedata} />
      <PreCallFeature preCallfeaturedata={preCallfeaturedata} />
      <WhyRexpt />
      {/* <CustomerExperience /> */}
    </div>
  );
};

export default FeaturePage;
